"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.validateBirthday=validateBirthday,exports.isOlderThan18=isOlderThan18,exports.calculateAge=calculateAge,exports.validateNameCharacters=validateNameCharacters,exports.validateCompleteName=validateCompleteName,exports.validatePhone=validatePhone,exports.validateEmail=validateEmail,exports.validateCnh=exports.validateCpf=void 0;var _validationsBr=require("validations-br"),validateCpf=function(a){if(a){a=a.replace(".",""),a=a.replace(".",""),a=a.replace("-","");var b,c,d,e,f,g=1;if(11>a.length)// se tem 11 digitos
return!1;for(e=0;e<a.length-1;e++)// buscar digitos iguais
if(a.charAt(e)!==a.charAt(e+1)){g=0;break}if(!g){for(b=a.substring(0,9),c=a.substring(9),d=0,e=10;1<e;e--)d+=b.charAt(10-e)*e;if(f=2>d%11?0:11-d%11,f!==+c.charAt(0))// primeiro digito validador
return!1;for(b=a.substring(0,10),d=0,e=11;1<e;e--)d+=b.charAt(11-e)*e;return f=2>d%11?0:11-d%11,f===+c.charAt(1)}return!1;// caso 1111111111 ou 2222222222
}return!1};exports.validateCpf=validateCpf;/**
 * Validate birthday given through parameters.
 *
 * Supported formats:
 * - DD/MM/YYYY
 *
 * @param {String} birthday The birthday to be validated
 * @returns {Boolean} True if the birthday is valid, false if the birthday is invalid
 */function validateBirthday(a){var b=a.split("/"),c=b[0],d=b[1],e=b[2],f=new Date().getFullYear();return!!(e&&c&&d)&&!(31<c||1>c)&&!(1>d||12<d)&&!(1900>e||e>f)}/**
 *
 * Check if a birthday given through parameters represents
 * an age greater than or equal to 18.
 *
 * Supported formats:
 * - DD/MM/YYYY
 *
 * @param {String} birthday The birthday to be checked
 * @returns {Boolean} True if the birthday is greater than or equal to 18,
 * false if the birthday less than 18
 */function isOlderThan18(a){var b=a.split("/"),c=b[0],d=b[1],e=b[2],f=calculateAge(new Date("".concat(e,"-").concat(d,"-").concat(c)));return!(18>f)}/**
 *
 * Calculate the age given a birthday through parameters.
 *
 * Supported formats:
 * - DD/MM/YYYY
 *
 * @param {String} birthday The birthday to be calculated
 * @returns {Number} The age in years
 */function calculateAge(a){// birthday is a date
var b=Date.now()-a.getTime(),c=new Date(b);// miliseconds from epoch
return Math.abs(c.getUTCFullYear()-1970)}/**
 * Validate a CNH given through parameters
 *
 * Supported formats:
 * - 00000000000
 * - 000000000
 *
 * @param {String} cnh The CNH to be validated
 * @returns {Boolean} True if the CNH is valid, false if the CNH is invalid
 */var validateCnh=function(a){var b=a.charAt(0);if(11!==a.replace(/[^\d]/g,"").length||b.repeat(11)===a)return!1;for(var c=0,d=9,e=0;9>c;++c,--d)e+=+(a.charAt(c)*d);var f=0,g=e%11;for(10<=g&&(g=0,f=2),c=0,d=1,e=0;9>c;++c,++d)e+=+(a.charAt(c)*d);var h=e%11,k=10<=h?0:h-f;return""+g+k===a.substr(-2)};/**
 * Validate the characters in a name given through parameters
 *
 * Supported characters:
 * - a-zA-ZáéíóúâêîôûãõàäëïöüÁÉÍÓÚÂÊÎÌÒÙÈÔÛÀÃÕÄËÏÖÜçÇ\sèñÈÑ-
 *
 * @param {String} name The name to be validated
 * @returns {Boolean} True if the characters in the name are valid, false if the characters in the name are invalid
 */exports.validateCnh=validateCnh;function validateNameCharacters(a){return /^([a-zA-ZáéíóúâêîôûãõàäëïöüÁÉÍÓÚÂÊÎÌÒÙÈÔÛÀÃÕÄËÏÖÜçÇ\sèñÈÑ-]+)+$/.test(a)}/**
 * Validate the characters and if there are more than one word in a complete name given through parameters
 *
 * Supported characters:
 * - a-zA-ZáéíóúâêîôûãõàäëïöüÁÉÍÓÚÂÊÎÌÒÙÈÔÛÀÃÕÄËÏÖÜçÇ\sèñÈÑ-
 *
 * Supported formarts:
 * - Maria das Neves
 * - maria das neves
 * - MARIA DAS NEVES
 *
 * @param {String} completeName The complete name to be validated
 * @returns {Boolean} True if the characters in the complete name are valid
 * and there is more than one word, false otherwise
 */function validateCompleteName(a){return /^[a-zA-ZáéíóúâêîôûãõàäëïöüÁÉÍÓÚÂÊÎÌÒÙÈÔÛÀÃÕÄËÏÖÜçÇ\sèñÈÑ-]+(?:\s[a-zA-ZáéíóúâêîôûãõàäëïöüÁÉÍÓÚÂÊÎÌÒÙÈÔÛÀÃÕÄËÏÖÜçÇ\sèñÈÑ-]+)+$/.test(a)}/**
 * Validate a phone number given through parameters
 *
 * Supported formarts:
 * - (99) 99999-9999
 *
 * @param {String} completeName The phone number to be validated
 * @returns {Boolean} True if the phone number is valid, false otherwise
 */function validatePhone(a){return(0,_validationsBr.validatePhone)(a)}/**
 * Validate a email given through parameters
 *
 * Supported formarts:
 * - email@server.com
 *
 * @param {String} email The email to be validated
 * @returns {Boolean} True if the email is valid, false otherwise
 */function validateEmail(a){return(0,_validationsBr.validateEmail)(a)}